export const jpForgotPassword = {
  SC50title: 'パスワードの再設定',
  SC50title1: 'パスワードの再設定',
  SC50heading1: '登録されているメールアドレスを入力してください。',
  SC50heading2: 'パスワード再設定用URLが記載されたメールをお送りします。',
  SC50submitReset: '送信する',
  SC50errorForgotPassword: '入力内容をご確認ください。',
  SC52changePasswordComplete: 'パスワードの変更が完了しました。',
}
